/* The two floating paints (design-owner decision 7: both looks stay) and the
 * selected-card paint. Paint only — border, fill, shadow, blur — never a
 * radius: each part keeps its own corner (decision 10). Engine tier so
 * molecules, shell, widgets and canvas can all read them. Internal: not
 * exported from the barrel. Literal class strings so Tailwind sees them. A new
 * floating part takes FLOATING_SURFACE unless it asks for GLASS_SURFACE on
 * purpose. */

/** The workspace paint: today's WorkspaceControlGroup rail. */
export const FLOATING_SURFACE =
  "border border-pb-border bg-pb-card-elevated/95 shadow-sm backdrop-blur-md";

/** The glass paint over a canvas: today's VSM selection bar. */
export const GLASS_SURFACE = "border glass shadow-[var(--pbds-shadow-float)]";

/** The one selected-card paint: the teal glow on a teal edge (ModuleCard,
 *  CanvasWidget and Card `selected`). Teal marks the selected state only
 *  (decision 3), so no other card state reuses it. */
export const SELECTED = "shadow-glow-selected border-pb-teal/40";
